module.exports = __webpack_public_path__ + "static/media/logo-KT-bw.ebf51b65.png";